import IconQuote from '../../../../../media/images/auth/icons/ic-quote.svg'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import '../styles/auth-swiper.scss'
import { Outlet, useLocation } from 'react-router-dom'
import { useRef } from 'react'
import AuthFloatingButton from './AuthFloatingButton'
import { useIntl } from 'react-intl'
import brandingConfig from '../../../../../config/brandingConfig'

export default function AuthSwiper() {
  const { formatMessage } = useIntl()
  const defaultImage = '/media/testimonials/generic.png'
  const secondDivRef = useRef<HTMLDivElement>(null);

  const scrollToDiv = () => {
    if (secondDivRef.current) {
      secondDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const lp = searchParams.get('lp')

  return (
    <>
      <AuthFloatingButton scrollToDiv={scrollToDiv} />
      <div
        className='col-md-8 bgImage h-md-100 order-md-1 order-2 adjuster'
        style={{
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
        }}
      >
        <div style={{ marginBottom: '40px' }}>
          <img src={brandingConfig.darkModeLogo} alt='Logo' height={42} />
        </div>

        <div className='mt-4'>
          <h1 className='text-light fs-1 m-auto fw-bold mb-4'>
            {formatMessage({ id: brandingConfig.authLandingPage.header })}
          </h1>
          <p className='text-muted fs-6 mb-6 desc'>
            {formatMessage({
              id: brandingConfig.authLandingPage.subHeader
            })}
          </p>
        </div>

        <div className='feature-list'>
          {brandingConfig.authLandingPage.features.map((feature, index) => (
            <div key={index} className={`d-flex align-items-center gap-2 lp-feature-parent ${lp === 'v2' ? 'mt-0' : 'mt-4'}`}>
              <img src={feature.image} alt='' />
              <div>
                <h2 className='text-light fs-5 m-0 lp-review-title'>{feature.heading}</h2>
                <p className={`text-muted m-0 py-1 ${lp === 'v2' ? 'd-none' : 'd-block'}`}>{feature.subHeading}</p>
              </div>
            </div>
          ))}
        </div>

        <div className='w-100 bg-white p-8 rounded-4 d-block d-sm-none' style={{ marginTop: '60px' }} ref={secondDivRef}>
          <Outlet />
        </div>

        <div className='' style={{ marginTop: '60px' }}>
          <h2 className='text-light fs-1 m-auto fw-bold mb-8'>{formatMessage({ id: `Benefits of ${brandingConfig.brandName}` })}</h2>

          <div className='benefits row d-flex'>
            {brandingConfig.authLandingPage.benefits.map((benefit, index) =>
              <div key={index} className='col-md-4 mb-4 d-md-flex'>
                <div className='bg-dark rounded-2 p-4 d-flex flex-column'>
                  <div className='mb-2'>
                    <img src={benefit.image} alt='' />
                  </div>
                  <div>
                    <h2 className='text-light fs-5'>{formatMessage({ id: benefit.heading })}</h2>
                    <p className='text-muted fs-7'>
                      {formatMessage({
                        id: benefit.subHeading
                      })}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ marginTop: '60px' }}>
          <h2 className='text-light fs-1 fw-bold mb-4'>{formatMessage({ id: `What Users Say` })}</h2>
          <div className='pt-4'>
            <Swiper
              breakpoints={{
                1440: {
                  slidesPerView: 3,
                },
                850: {
                  slidesPerView: 2,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
              loop={true}
              // slidesPerView={3}
              spaceBetween={24}
              autoplay={{ delay: 4000 }}
              modules={[Pagination, Autoplay]}
              className='swipertestomonial'
            >
              {brandingConfig.authLandingPage.reviews.map((review, index) => (
                <SwiperSlide style={brandingConfig.brandName === 'Foundercrate' ? { minHeight: '200px' } : { minHeight: '230px' }}>
                  <div className='lp-testmonial text-start p-5 rounded-2 bg-dark border-0' style={brandingConfig.brandName === 'Foundercrate' ? { position: 'relative', paddingTop: '40px', minHeight: '170px' } : { position: 'relative', paddingTop: '40px', minHeight: '200px' }}>
                    <img src={IconQuote} alt='' className='lp-quote-icon' style={{ position: 'absolute', top: '-20px' }} />
                    <div className='mt-6'>
                      <div key={index}>
                        <p className='text-light fs-7'>{review.reviewDesc}</p>
                      </div>
                      <div className='d-flex gap-2 mt-8'>
                        <img
                          className='lp-profile-image'
                          src={review.profilePic && review.profilePic ? review.profilePic : defaultImage}
                          alt='testimonial of user'
                        />
                        <div>
                          <h1 className='text-light fs-6 m-0'>{review.name}</h1>
                          <p className='text-muted fs-7 m-0 mt-1'>{review.position}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        <div className='' style={{ marginTop: '60px' }}>
          <h2 className='text-light fs-1 m-auto fw-bold mb-8'>{formatMessage({ id: `Frequently Asked Questions` })}</h2>
          <div className='faqs'>
            <div className="accordion lp-accordion" id="accordionExample">
              {brandingConfig.authLandingPage.faqs.map((faqs, index) => {
                const uniqueId = `collapse-${index}`;
                const isFirstItem = index === 0;
                return (
                  <div key={index} className="accordion-item bg-dark lp-ac-item mb-3 w-100">
                    <h2 className="accordion-header" id={`heading-${index}`}>
                      <button
                        className="accordion-button bg-dark text-light fs-5 fw-normal"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${uniqueId}`}
                        aria-expanded={isFirstItem ? "true" : "false"}
                        aria-controls={uniqueId}
                      >
                        {formatMessage({ id: faqs.question })}
                      </button>
                    </h2>
                    <div
                      id={uniqueId}
                      className={`accordion-collapse collapse ${isFirstItem ? "show" : ""}`}
                      aria-labelledby={`heading-${index}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body text-light">
                        <p>{formatMessage({ id: faqs.answer })}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
